export const ENDPOINT = {
    msAdmin: {
        api: '/api/msAdmin',
        bodegasSucursales: '/bodegasSucursales',
        clasificacionClientes: '/clasificacionClientes',
        clientes: '/clientes',
        cuentasCorriente: '/cuentasCorriente',
        sucursales: '/sucursales',
        familiaNivel1: '/familiaNivel1',
        familiaNivel2: '/familiaNivel2',
        familiaNivel3: '/familiaNivel3',
        kardex: '/kardex',
        menuOptions: '/menuOptions',
        opcionProducto: '/opcionProducto',
        opcionesProducto: '/opcionesProducto',
        roles: '/roles',
        usuarios: '/usuarios'
    },
    msCargaMasiva: {
        api: '/api/msCargaMasiva'
    },
    msCompras: {
        api: '/api/msCompras',
        compras: '/compras',
        ordenesCompras: '/ordenesCompras'
    },
    msCuentas: {
        api: '/api/msCuentas',
        cobradores: '/cobradores'
    },
    msCXP: {
        api: '/api/msCXP',
        proveedores: '/proveedores'
    },
    msInventarios: {
        api: '/api/msInventarios',
        ajustes: '/ajustes',
        productos: '/productos',
        productosCodigosAlternos: '/productosCodigosAlternos',
        productosComponentes: '/productosComponentes',
        servicios: '/servicios',
        serviciosProductos: '/serviciosProductos',
        serviciosCliente: '/serviciosCliente',
    },
    msInstancias: {
        api: '/api/msInstancias',
        connections: '/connections'
    },
    msLogin: {
        api: '/api/msLogin',
        login: '/login'
    },
    msOtros: {
        api: '/api/msOtros',
        empresas: '/empresas',
        empresaConfig: '/empresaConfig',
        nomenclaturas: '/nomenclaturas',
        centrosCosto: '/centrosCosto',
        medidas: '/medidas',
        archivosExtensiones: '/archivosExtensiones',
        monedas: '/monedas',
        hrmDepartamentos: '/hrmDepartamentos',
        bancos: '/bancos',
        statusEmpleado: '/statusEmpleado',
        tipoProductos: '/tipoProductos',
        marcas: '/marcas',
        grupos: '/grupos',
        precioMoneda: '/precioMoneda',
        documentosCorrelativos: '/documentosCorrelativos',
        sectoresNivel1: '/sectoresNivel1',
        sectoresNivel2: '/sectoresNivel2',
        recurrencias: '/recurrencias',
        modulosPaginas: '/modulosPaginas'
    },
    msReporteria: {
        api: '/api/msReporteria',
        reportes: '/reportes'
    },
    msPoliticas: {
        api: '/api/msPoliticas',
        politicas: '/politicas'
    },
    msConfiguraciones: {
        api: '/api/msConfiguraciones',
        magnitudes: '/magnitudes',
        unidades: '/unidades',
        medidas: '/medidas',
        equivalencias: '/equivalencias'
    },
    msRequisiciones: {
        api: '/api/msRequisiciones',
        estados: '/estados',
        requisicionPlantilla: '/requisicionesPlantilla',
        requisicionPlantillaDetalle: '/requiPlantillaDetalle'
    },
    msRestaurante: {
        api: '/api/msRestaurante',
        mesas: '/mesas',
        areasMesas: '/areasMesas',
        areaImpresoras: '/areaImpresoras'
    },
    msCobros: {
        api: '/api/msCobros',
        tiposDeCobro: '/tiposDeCobro'
    }
};
